import VGDailyDealDetail from "../../VagaroComponent/VGDailyDealDetail";
import { UserContext } from "../Definitions/UserContext";
import React from "react";
import ReactDOM from "react-dom";
import { utils } from "../../utils/Utils";
import { getDailyDeals } from "./BusinessData";

export function OpenDailyDealFromURL(url:string,userContext:UserContext,onComplete?:()=>void,onError?:()=>void){



    getDailyDeals(userContext,(data:any)=>{

        
        if(data.dailyDealList){

            let deal = data.dailyDealList.find((deal:any)=>deal.dailyDealURL == url);

            if(deal){
                opendailypop({data:deal,layout:"1",siteData:userContext,salontime:deal.salonTime});
                onComplete&&onComplete();
                return;
            }


        }
        onError&&onError();

        window.alert("Oop! We had trouble getting that deal. Please try again later.");

    },(error:any)=>{
        onError&&onError();

            window.alert("Oop! We had trouble getting that deal. Please try again later.");
    });



    
    function opendailypop({ data, layout, siteData,salontime }: { data: any, layout: string, siteData: any,salontime:any }) {  
        var LoginDetails = utils.ReadCookie();  
        return ReactDOM.render(
            <VGDailyDealDetail
                data={data}
                salontime={salontime}
                siteData={siteData}    
                LoginDetails={LoginDetails}        
            />,
            document.getElementById("OpenDialog")
        )
    }
    
}